var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReorderSet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_27_38)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 67,
    height: 67,
    rx: 11.5,
    fill: "#3EC6CA",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7293 10.0228C26.1826 10.0313 27.4093 10.0356 28.3214 10.5211C28.9188 10.8391 29.4144 11.2953 29.7579 11.8438C30.2826 12.681 30.2787 13.8025 30.2709 16.0456C30.2631 18.2887 30.2592 19.4102 29.7287 20.2437C29.3813 20.7898 28.8826 21.2425 28.283 21.5564C27.3676 22.0355 26.1409 22.0313 23.6876 22.0227C21.2343 22.0142 20.0076 22.0099 19.0956 21.5245C18.4982 21.2064 18.0026 20.7502 17.659 20.2018C17.1343 19.3646 17.1382 18.243 17.146 16C17.1538 13.7569 17.1577 12.6354 17.6882 11.8018C18.0356 11.2558 18.5343 10.803 19.1339 10.4891C20.0494 10.01 21.276 10.0143 23.7293 10.0228Z",
    fill: "#3EC6CA",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6667 28.0227C26.12 28.0312 27.3467 28.0355 28.2588 28.521C28.8562 28.839 29.3518 29.2953 29.6953 29.8437C30.22 30.6809 30.2161 31.8024 30.2083 34.0455C30.2005 36.2885 30.1966 37.41 29.6661 38.2436C29.3188 38.7896 28.82 39.2424 28.2204 39.5562C27.305 40.0354 26.0783 40.0311 23.625 40.0226C21.1717 40.0141 19.9451 40.0098 19.033 39.5243C18.4356 39.2063 17.94 38.75 17.5964 38.2017C17.0717 37.3644 17.0756 36.2429 17.0834 33.9998C17.0912 31.7568 17.0951 30.6353 17.6256 29.8017C17.973 29.2557 18.4717 28.8029 19.0713 28.489C19.9868 28.0099 21.2134 28.0142 23.6667 28.0227Z",
    fill: "#3EC6CA",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6042 46.0226C26.0575 46.0311 27.2841 46.0354 28.1962 46.521C28.7936 46.8389 29.2892 47.2952 29.6327 47.8436C30.1575 48.6808 30.1536 49.8023 30.1458 52.0454C30.138 54.2884 30.1341 55.4099 29.6035 56.2435C29.2562 56.7895 28.7574 57.2423 28.1579 57.5561C27.2424 58.0353 26.0158 58.0311 23.5625 58.0225C21.1091 58.014 19.8825 58.0097 18.9704 57.5242C18.373 57.2062 17.8774 56.75 17.5339 56.2016C17.0092 55.3643 17.0131 54.2428 17.0209 51.9997C17.0286 49.7567 17.0325 48.6352 17.5631 47.8016C17.9104 47.2556 18.4092 46.8028 19.0088 46.489C19.9242 46.0098 21.1509 46.0141 23.6042 46.0226Z",
    fill: "#3EC6CA",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2709 16.0456L46.0208 16.1003C52.208 16.1218 55.3015 16.1326 57.2175 17.8966C59.1335 19.6607 59.1237 22.4891 59.104 28.1459L59.0957 30.5459M59.0623 40.1458C59.0426 45.8026 59.0328 48.631 57.1046 50.3818C55.1764 52.1324 52.0828 52.1216 45.8957 52.1001L38.0207 52.0728M38.0207 52.0728L43.254 56.891ZM38.0207 52.0728L43.2874 47.291Z",
    fill: "#3EC6CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2709 16.0456L46.0208 16.1003C52.208 16.1218 55.3015 16.1326 57.2175 17.8966C59.1335 19.6607 59.1237 22.4891 59.104 28.1459L59.0957 30.5459M59.0623 40.1458C59.0426 45.8026 59.0328 48.631 57.1046 50.3818C55.1764 52.1324 52.0828 52.1216 45.8957 52.1001L38.0207 52.0728M38.0207 52.0728L43.254 56.891M38.0207 52.0728L43.2874 47.291",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_27_38",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27_38",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReorderSet);
export default __webpack_public_path__ + "static/media/reorder-set.bad21fdc9438921bee65b390b240168f.svg";
export { ForwardRef as ReactComponent };